export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_MODULO_PAGINA_ID':
      return { ...state, idModuloPagina: action.idModuloPagina };
    case 'ADD_PAGINA_ID':
      return { ...state, idPagina: action.idPagina };
    default:
      return state;
  }
};
